import { render, staticRenderFns } from "./logistics_address.vue?vue&type=template&id=70abb99e"
import script from "./logistics_address.vue?vue&type=script&lang=js"
export * from "./logistics_address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports